import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class HomeBoxes extends Component {
    
  render(props) {
    return (
        <div className="homeBoxes-outer">
            <div className="container homeBoxes">
                <div className="row">
                    <div className="col-sm-4">
                        <h3><Link to="/services">Services</Link></h3>
                        <p>SLA is a full-service provider of <Link to="/services/tradeshow_management">tradeshow</Link> and <Link to="/services/exhibit_management">exhibit management</Link>. Owning an exhibit and attending tradeshows requires a lot of effort, but SLA Service Management can help lighten that load!</p>
                    </div>
                    <div className="col-sm-4">
                        <h3><Link to="/displays">Displays</Link></h3>
                        <p>Whether it's the <Link to="/services/exhibit_management">care or refurbishing</Link> of your existing exhibit or the <Link to="/services/exhibit_management">design and build</Link> of a new exhibit - from the <Link to="/displays">lightest ultra-portable</Link> to the largest <Link to="/displays">custom build</Link> - SLA will make you and your exhibit shine!</p>
                    </div>
                    <div className="col-sm-4">
                        <h3><Link to="/design">Design</Link></h3>
                        <p>You expect your company's personality to reflect in all of your marketing materials - from business cards and brochures to exhibits and giveaways. SLA's <Link to="/design">design services</Link> will faithfully promote your brand and get you noticed!</p>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default HomeBoxes;


// WEBPACK FOOTER //
// ./src/components/HomeBoxes/HomeBoxes.js